(ns dre.pages.admin.ai-summarization-usage.events
  (:require
   ["dayjs" :as dayjs]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.coll :as dre-coll]
   [dre.network :as-alias network]
   [dre.pages.admin.ai-summarization-usage.db :refer [init-db]]
   [dre.page-util :refer [query-params]]
   [dre.shared.interface.search.pills :as pills-util]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:pages :admin :ai-summarization-usage])


(defn- update-state
  [db k state]
  (assoc-in db [k :state] state))

(defn- remove-nils
  "Accepts a hashmap and dissoc nil values

   TODO: move to better ns

   I've created this fn because dre.coll/nn-hash-map is excluding false values too"
  [hm]
  (->> hm
       (filter (fn [[_ v]]
                 (some? v)))
       (into {})))

(defn ->query-params
  [filters pagination type]
  (let [filters (-> filters
                    (update :from #(.format % "YYYY-MM-DD"))
                    (update :to #(.format % "YYYY-MM-DD")))
        ;; when we're fetching events include pagination
        filters  (if (= :events type)
                   (merge filters pagination)
                   filters)
        filters (case type
                  :url filters
                  :events filters
                  :user-list (dissoc filters :username) ; exclude username filter
                  :client-list (dissoc filters :username :client) ; exclude username and client filters
                  )
        filters (if (or (= :user-list type) (= :client-list type))
                  {:from (.format (.add (dayjs) -365 "d") "YYYY-MM-DD")
                   :to (.format (dayjs) "YYYY-MM-DD")
                   :include-dre true
                   :include-browser true
                   :include-api true}
                  filters)
        ;; username and client params can be nil but we shouldn't send those to api when they're nil
        filters (remove-nils filters)]
    filters))

(defn filters->url
  [state]
  (->query-params (:filters state) nil :url))

(defn url->filters
  [query-params]
  (if (not (empty? query-params))
    (-> query-params
        (update :from (partial dayjs))
        (update :to (partial dayjs))
        (update :include-dre parse-boolean)
        (update :include-browser parse-boolean)
        (update :include-api parse-boolean))
    nil))

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [new-route]]
  (let [filters (url->filters (query-params new-route))
        to (dayjs)
        from (.add (dayjs) -7 "d")
        filters? filters]
    {:db (update init-db :filters merge (if filters?
                                          filters
                                          {:from from :to to}))
     :fx [[:dispatch [::fetch-report {:type :client-list
                                      :endpoint :admin/usage.top-clients}]]
          [:dispatch [::fetch-report {:type :user-list
                                      :endpoint :admin/usage.top-users}]]
          [:dispatch [::fetch-reports]]]})))

(rf/reg-event-fx
 ::fetch-report
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [type endpoint updated-pagination] :as opts}]]
  (let [pagination (if updated-pagination
                     updated-pagination
                     (get-in db [:events :pagination]))
        params (->query-params (:filters db) (dissoc pagination :current-page) type)]
    {:db (-> (update-state db type :loading)
             (assoc-in [:events :pagination] pagination))
     :fx [[::network/request [{:endpoint endpoint}
                              {:response-content-type :json
                               :params params
                               :on-success [::fetch-report-on-ok opts]
                               :on-failure [::fetch-report-on-nok opts]}]]]})))

(rf/reg-event-fx
 ::fetch-report-on-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]
              :keys [type]}]]
  {:db (-> (update-state db type :success)
           (assoc-in [type :response] (:body response)))}))

(rf/reg-event-fx
 ::fetch-report-on-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]
              :keys [type]}]]
  {:db (update-state db type :failure)
   :dispatch [:dre.network/default-failure {:event :admin-ai-summary}]}))

(rf/reg-event-fx
 ::fetch-reports
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:db (-> (assoc-in db [:events :pagination :offset] 0)
           (assoc-in [:events :pagination :current-page] 1))
   :fx [[:dispatch [::fetch-report {:type :events
                                    :endpoint :admin/usage.ai-summary-events}]]]}))

(rf/reg-event-db
 ::on-filter-change
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [path v]]
  (assoc-in db (if (vector? path)
                 (concat [:filters] path)
                 [:filters path])
            v)))

(rf/reg-event-db
 ::on-date-filter-change
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [{:keys [start end]}]]
  (-> db
      (assoc-in [:filters :from] start)
      (assoc-in [:filters :to] end))))

(rf/reg-event-fx
 ::filter-by-company
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [db]} [{:keys [client]}]]
  {:db (assoc-in db [:filters :client] client)
   :fx [[:dispatch [::fetch-reports]]
        [:dispatch [::select-tab :events]]]}))

(rf/reg-event-fx
 ::filter-by-user
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [db]} [{:keys [username]}]]
  {:db (assoc-in db [:filters :username] username)
   :fx [[:dispatch [::fetch-reports]]
        [:dispatch [::select-tab :events]]]}))

; ---

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::events
 :<- [::state]
 (fn [state _]
   (:events state)))

(rf/reg-sub
 ::events-datasource
 :<- [::events]
 (fn [events _]
   (->> events
        :response
        :events
        (map (fn [{:keys [_created username profile payload meta vote_meta]}]
               {:time _created
                :email username
                :client (:client profile)
                :pills (when-let [pills (pills-util/coerce payload)]
                         (let [pill (pills-util/flats->pill pills)
                               normalized (pills-util/normalize pill)
                               flats (pills-util/pills->flats [normalized])]
                           flats))
                :meta meta
                :vote-meta vote_meta})))))

(rf/reg-sub
 ::events-state
 :<- [::events]
 (fn [events _]
   (get-in events [:state])))

(rf/reg-sub
 ::filters
 :<- [::state]
 (fn [state _]
   (:filters state)))

(rf/reg-sub
 ::value-of-filter
 :<- [::filters]
 (fn [filters [_ path]]
   (if (vector? path)
     (get-in filters path)
     (get filters path))))

(rf/reg-sub
 ::client-list
 :<- [::state]
 (fn [state _]
   (:client-list state)))

(rf/reg-sub
 ::client-list-datasource
 :<- [::client-list]
 (fn [client-list _]
   (map #(hash-map :value (:client %) :label (:client %)) (get-in client-list [:response :top-clients]))))

(rf/reg-sub
 ::user-list
 :<- [::state]
 (fn [state _]
   (:user-list state)))

(rf/reg-sub
 ::user-list-datasource
 :<- [::user-list]
 (fn [user-list _]
   (map #(hash-map :value (:username %) :label (:username %)) (get-in user-list [:response :top-users]))))
